export const FIELD_VALUES_PAGINATION_PAGE_SIZE = 15_000
